import React from 'react';
import TenantMobileLayout from './TenantMobileLayout';
import HACCPPage from '../../pages/HACCPPage';

const TenantMobileHACCP = ({ onBack, initialSection }) => {
  return (
    <TenantMobileLayout title="HACCP" onBack={onBack}>
      <div className="mobile-content-wrapper">
        <HACCPPage initialSection={initialSection} />
      </div>
    </TenantMobileLayout>
  );
};

export default TenantMobileHACCP;
